import { Typography } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const ListItemText = styled(Typography) `
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
